import { httpClient } from "@/shared/infrastructure/http/http-client";
import type { HealthSummary, ImpactFactor, UserProfile } from "../../domain/entities";
import type { UpdateUserInput, UsersRepositoryPort } from "../../application/ports/users.repository.port";

export const usersHttpRepository: UsersRepositoryPort = {
  getById(id: string): Promise<UserProfile> {
    return httpClient<UserProfile>(`/users/${id}`);
  },

  getHealthSummary(id: string): Promise<HealthSummary> {
    return httpClient<HealthSummary>(`/users/${id}/health-summary`);
  },

  getImpactFactors(id: string): Promise<ImpactFactor[]> {
    return httpClient<ImpactFactor[]>(`/users/${id}/impact-factors`);
  },

  update(id: string, input: UpdateUserInput): Promise<UserProfile> {
    return httpClient<UserProfile>(`/users/${id}`, { method: "PUT", body: input });
  },

  uploadAvatar(id: string, file: File): Promise<UserProfile> {
    const formData = new FormData();
    formData.append("file", file);
    return httpClient<UserProfile>(`/users/${id}/avatar`, { method: "POST", body: formData });
  },
};
